import { HYPHEN, PLUS } from './consts';
import { SignOptions } from '../types';

interface Props {
  formatted: string;
  rounded: number;
  withSign: SignOptions;
}

// formattedValue can only start with hyphen (not plus or minus)
export function editSign({ formatted, rounded, withSign }: Props) {
  const isZero = rounded === 0;
  const isZeroWithHyphen = isZero && formatted.startsWith(HYPHEN);

  const preEdited = isZeroWithHyphen ? formatted.substring(1) : formatted;
  const hasHyphen = preEdited.startsWith(HYPHEN);
  const isPositive = !hasHyphen && !isZero;

  switch (withSign) {
    case 'never':
      return hasHyphen ? preEdited.substring(1) : preEdited;
    case 'always':
      return isPositive ? `${PLUS}${preEdited}` : preEdited;
    default:
      return preEdited;
  }
}
